import apiService from './api';

// Глобальное хранилище услуг
let globalServices = {
  allServices: [],
  servicesByCategory: {},
  loading: false,
  loaded: false,
  error: null,
  listeners: []
};

// Уведомляем всех подписчиков
const notifyListeners = () => {
  globalServices.listeners.forEach(listener => listener(globalServices));
};

// Основная функция загрузки услуг
export const loadAllServices = async () => {
  if (globalServices.loaded) {
    return globalServices;
  }
  
  if (globalServices.loading) {
    return new Promise((resolve) => {
      globalServices.listeners.push(() => resolve(globalServices));
    });
  }
  
  globalServices.loading = true;
  notifyListeners();
  
  try {
    const data = await apiService.getServices();
    
    if (data && data.length > 0) {
      globalServices.allServices = data;
      
      // Группируем по категориям
      globalServices.servicesByCategory = {};
      data.forEach(service => {
        const category = service.category_name;
        if (!globalServices.servicesByCategory[category]) {
          globalServices.servicesByCategory[category] = [];
        }
        globalServices.servicesByCategory[category].push(service);
      });
      
      globalServices.loaded = true;
      
      // Сохраняем в localStorage
      localStorage.setItem('cached_services', JSON.stringify({
        allServices: globalServices.allServices,
        servicesByCategory: globalServices.servicesByCategory,
        timestamp: Date.now()
      }));
      
      console.log('✅ Услуги загружены:', globalServices.allServices.length);
    } else {
      throw new Error('Нет данных');
    }
    
  } catch (error) {
    console.error('❌ Ошибка загрузки:', error);
    
    // Пробуем загрузить из кэша
    const cached = localStorage.getItem('cached_services');
    if (cached) {
      const { allServices, servicesByCategory } = JSON.parse(cached);
      globalServices.allServices = allServices;
      globalServices.servicesByCategory = servicesByCategory;
      globalServices.loaded = true;
      console.log('📦 Услуги загружены из кэша');
    } else {
      globalServices.error = error.message;
    }
  } finally {
    globalServices.loading = false;
    notifyListeners();
  }
  
  return globalServices;
};

// Получить все услуги
export const getAllServices = () => {
  return globalServices.allServices;
};

// Получить услуги по категории
export const getServicesByCategory = (categoryName) => {
  return globalServices.servicesByCategory[categoryName] || [];
};

// Получить услугу по ID
export const getServiceById = (id) => {
  return globalServices.allServices.find(s => s.id === parseInt(id));
};

// Обновить кэш после редактирования
export const refreshServices = async () => {
  globalServices.loaded = false;
  globalServices.allServices = [];
  globalServices.servicesByCategory = {};
  return await loadAllServices();
};